<app-dialog-page>
    <app-forgot-password-form
        [error]="error"
        (resetEvent)="reset($event)"
    ></app-forgot-password-form>
</app-dialog-page>
